import * as React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import {
    Button, Typography, TextField,
} from '@material-ui/core';

import * as AuthStore from '../../../app/store/AuthStore';
import urls from '../../../app/urls';

const styles = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 400,
    },
    header: {
        marginBottom: theme.spacing(3),
    },
    loginDescription: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
    textField: {
        marginBottom: theme.spacing(2),
    },
    codeInput: {
        textTransform: 'uppercase',
    },
    studentLoginButton: {
        alignSelf: 'center',
    },
});


class Login extends React.Component {
    state = {
        patientCode: '',
    };

    handleChange = name => (event) => {
        this.setState({ [name]: event.target.value });
    };

    handleKeyPressPatientCode = (e) => {
        if (e.key === 'Enter' && this.state.patientCode) {
            this.loginPatientCode();
        }
    };

    loginPatientCode = () => {
        if (this.state.patientCode) {
            this.props.redirect(`${urls.studentCode.home}/${this.state.patientCode}`);
        }
    }

    render() {
        const {
            classes, translate, loading,
        } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.patientLogin}>
                    <div className={classes.header}>
                        <Typography variant="h6">
                            {translate('login.studentLogin')}
                        </Typography>
                        <Typography variant="caption" className={classes.loginDescription}>
                            {translate('login.studentLoginDescription')}
                        </Typography>
                    </div>

                    <TextField
                        id="patientCode"
                        label={translate('login.studentCode')}
                        className={classes.textField}
                        value={this.state.patientCode}
                        onChange={this.handleChange('patientCode')}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        InputProps={{
                            classes: { input: classes.codeInput },
                            onKeyPress: this.handleKeyPressPatientCode,
                        }}
                    />
                    <Button className={classes.studentLoginButton} onClick={this.loginPatientCode} variant="contained" color="primary" disabled={loading}>
                        {translate('login.login')}
                    </Button>
                </div>
            </div>
        );
    }
}

Login.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    redirect: PropTypes.func.isRequired,
    loading: PropTypes.bool,
};

Login.defaultProps = {
    loading: false,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    loading: state.auth.loading,
    errorMessage: [].concat(state.auth.errors).filter(val => val).join('<br/>'),
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(AuthStore.actionCreators, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Login)));
